import React, { useEffect, useState } from 'react';
import ServiceOverdue from './Overdue';
import UpcomingDue from './UpcomingDue';
import UpcomingRemainder from './UpcomingRemainder';
import { useDispatch } from 'react-redux';
import { removeAllBreadCrumb, setBreadCrumb } from '../../../../store/reducers/menu_reducer';
import { getAllDashboardCount } from '../../../../services/vm/apiController';
import FactoryDropdown from '../../FactoryDropdown';
import DashCountDetail from '../../../../components/atoms/DashCountDetail';

const Home = () => {
  const dispatch = useDispatch();
  const [dashboardCounts, setDashboardCounts] = useState('');

  useEffect(() => {
    dispatch(removeAllBreadCrumb());
    dispatch(
      setBreadCrumb({
        label: 'Dashboard',
        value: '/home',
      })
    );
    showAllCounts();
  }, []);

  const showAllCounts = async () => {
    const vehicleAllCounts = await getAllDashboardCount();
    setDashboardCounts(vehicleAllCounts.data);
  };

  return (
    <React.Fragment>
      <p>
        <FactoryDropdown onFactoryChange={showAllCounts} />
      </p>
      <div className="dash-count-parent-wrapper">
        <VehicleCount
          link={dashboardCounts.pendingRequestCounts > 0 ? '/vm/vehicle-requests' : ''}
          title="Vehicle Requests"
          count={dashboardCounts.pendingRequestCounts}
        />
        <VehicleCount
          link={dashboardCounts.scrapResellCounts > 0 ? '/vm/running-vehicle' : ''}
          title="Scrap/Resell Vehicle"
          count={dashboardCounts.scrapResellCounts}
        />
        <VehicleRequestCount
          link={dashboardCounts.pendingRequestCounts > 0 ? '/vm/vehicle-requests?status=VEHICLE REQUESTED' : ''}
          title="# Pending Requests"
          count={dashboardCounts.pendingRequestCounts}
          caption="Need immediate action"
          cardType="danger"
        />
        <VehicleRequestCount
          link={dashboardCounts.pendingPoCounts > 0 ? '/vm/vehicle-requests?status=PO REQUESTED' : ''}
          title="# Pending PO(s)"
          count={dashboardCounts.pendingPoCounts}
          caption="Need immediate action"
          cardType="danger"
        />
        <VehicleRequestCount title="Spare Request" count={dashboardCounts.spareReqCounts} cardType="danger" />
        <VehicleRequestCount title="Spare Request Pending" count={dashboardCounts.pendingSpareReqCounts} cardType="danger" />
        <VehicleRequestCount title="Breakdown Pending" count={dashboardCounts.pendingBreakdownReqCounts} cardType="danger" />
        <VehicleRequestCount
          link={dashboardCounts.runningVehicleCounts - dashboardCounts.scrapResellCounts > 0 ? '/vm/running-vehicle' : ''}
          title="Running Vehicle"
          count={dashboardCounts.runningVehicleCounts - dashboardCounts.scrapResellCounts}
          cardType="danger"
        />
      </div>
      <div className="dash-parent-wrapper">
        <DashCard>
          <UpcomingDue />
        </DashCard>
        <DashCard>
          <ServiceOverdue />
        </DashCard>
        <DashCard>
          <UpcomingRemainder />
        </DashCard>
      </div>
    </React.Fragment>
  );
};

const DashCard = (props) => {
  return <div className="dash-card">{props.children}</div>;
};

const VehicleCount = ({ link, title, count, caption }) => {
  return <DashCountDetail link={link} title={title} value={count} caption={caption} />;
};

const VehicleRequestCount = ({ link, title, caption, count }) => {
  return <DashCountDetail link={link} title={title} value={count} caption={caption} />;
};

export default Home;
